export default __webpack_public_path__ + "static/media/cesto_insalata.1a622a43.svg";